export async function indexSubclientsUseCase(client_id, subclientRepostitory) {

    const res = await subclientRepostitory.index_sublcients(client_id);

    res.data.forEach(x => {
        const entity = new subclientRepostitory.model_index(x);

        if (!entity.isValid()) {
           throw new Error("subcliente inválido");
        }
    })
    
    return res.data;
}